import { render } from "./TopAccountMenu.vue?vue&type=template&id=600927c5&scoped=true"
import script from "./TopAccountMenu.vue?vue&type=script&lang=js"
export * from "./TopAccountMenu.vue?vue&type=script&lang=js"

import "./TopAccountMenu.vue?vue&type=style&index=0&id=600927c5&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600927c5"]])

export default __exports__